import React, { useEffect, useState } from "react";
import Search from "../Search/Search";
import CreateNewDocuments from "../ReusedComponents/CreateNewDocuments/CreateNewDocuments";
import { onHandleShowTableMenu } from "../../utils/OnHandleShowTableMenu/OnHandleShowTableMenu";
import moreBtnTableIcon from "../../img/moreButtonTable.svg";
import TableRowMenu from "../ReusedComponents/TableRowMenu/TableRowMenu";
import SelectedDocSetBol from "../SelectedDocSetBol/SelectedDocSetBol";
import { findStatusDocument } from "../../utils/FindStatusDocument/FindStatusDocument";
import useAuth from "../../utils/CustomHooks/useAuth/useAuth";
import CreateDocSetBolModal from "../CreateDocSetBolModal/CreateDocSetBolModal";
import useAxiosPrivate from "../../utils/CustomHooks/useAxiosPrivate/useAxiosPrivate";
import { axiosPutUpdateBolOnlyBolsTable } from "../../Api/ApiBol/axiosPutUpdateBolOnlyBolsTable";

const Bol = (props) => {
  const { getListBol } = props;

  const [filter, setFilter] = useState("");

  const [activeBolTable, setActiveBolTable] = useState(true);
  const [activeSelectDoc, setActiveSelectDoc] = useState(false);
  const [selectedCargoCaseBol, setSelectedCargoCaseBol] = useState([]);
  const [activeTableRowMenu, setActiveTableRowMenu] = useState(null);
  const [editDoc, setEditDoc] = useState(false);
  const [activeCreateBolModal, setActiveCreateBolModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const {
    setNameDocHeader,
    getRequestDataToggle,
    cleanIdUpdateBol,
    getIdUpdateBol,
    stateReducer,
  } = useAuth();
  const axiosPrivate = useAxiosPrivate();

  useEffect(() => {
    let isMounted = true;

    if (getListBol.length > 0) {
      isMounted && setActiveBolTable(true);
    } else {
      isMounted && setActiveBolTable(false);
    }

    return () => {
      isMounted = false;
    };
  }, [getListBol.length]);

  function onShowCurrentDoc(id) {
    const currentCargoCaseBol = getListBol.find((el) => el.id === id);
    setActiveSelectDoc(true);
    setNameDocHeader(currentCargoCaseBol?.bookingRef);
    setSelectedCargoCaseBol([currentCargoCaseBol]);
  }

  function addBolCargoCase(body, currentId) {
    if (editDoc === true && currentId !== undefined) {
      axiosPutUpdateBolOnlyBolsTable(
        axiosPrivate,
        currentId,
        body,
        getRequestDataToggle,
        getIdUpdateBol,
        setEditDoc,
        setActiveCreateBolModal,
        setErrorMessage
      );
    } else {
      closeModal();
    }
  }

  useEffect(() => {
    if (stateReducer.idUpdateBol !== null) {
      const currentCargoCaseBol = getListBol.find(
        (el) => el?.id === stateReducer.idUpdateBol
      );
      setNameDocHeader(currentCargoCaseBol?.bookingRef);
      setSelectedCargoCaseBol([currentCargoCaseBol]);
      cleanIdUpdateBol();
    }
  }, [getListBol]);


  useEffect(() => {
    let isMounted = true;

    if (getListBol.length > 0) {
      isMounted && setActiveBolTable(true);
      isMounted && setActiveSelectDoc(false);
      isMounted && setNameDocHeader("");
      isMounted && setSelectedCargoCaseBol([]);
      isMounted && setActiveTableRowMenu(null);
    } else {
      isMounted && setActiveBolTable(false);
    }

    return () => {
      isMounted = false;
    };
  }, [stateReducer.toggleBackPage]);

  function onEditActiveMode() {
    if (editDoc === false) {
      setActiveCreateBolModal(true);
      setEditDoc(true);
    }
  }

  function onSelectedBol(id) {}

  const closeModal = () => {
    setActiveCreateBolModal(false);
    setEditDoc(false);
  };

  return (
    <div className="bol__container">
      <div
        className={
          activeSelectDoc
            ? "bol-search-create-button hide"
            : "bol-search-create-button"
        }
      >
        <Search value={filter} setValue={setFilter} />
      </div>
      <div className="bol-main-block">
        {activeBolTable ? (
          <>
            {activeSelectDoc ? (
              <div className="bol__selected">
                <SelectedDocSetBol
                  selectedCargoCaseBol={selectedCargoCaseBol}
                  cargoCaseDocId={selectedCargoCaseBol[0]?.cargoCase?.id}
                  onEditHandler={() => onEditActiveMode()}
                />
              </div>
            ) : (
              <div className="bol__table">
                <div className="bol__table-block">
                  <div className="bol__table-header">
                    <p>B/L No.</p>
                    <p>Data</p>
                    <p>Gross quantity (kilos)</p>
                    <p>Description of goods</p>
                    <p>Net quantity</p>
                    <p>BBLS gross</p>
                    <p>BBLS net</p>
                    <p>Status</p>
                  </div>
                  {getListBol
                    .filter((bol) =>
                      bol.bookingRef
                        .toLowerCase()
                        .includes(filter.toLowerCase())
                    )
                    .map((el) => {
                      return (
                        <div
                          onClick={() => onShowCurrentDoc(el?.id)}
                          key={el?.id}
                          className="bol__table-row"
                        >
                          <p>{el?.bookingRef}</p>
                          <p>{el?.dateOfLoading}</p>
                          <p>{el?.grossQuantity}</p>
                          <p>{el?.descriptionOfGoods}</p>
                          <p>{el?.netQuantity}</p>
                          <p>{el?.bblsGross}</p>
                          <p>{el?.bblsNet}</p>
                          <div className="cargo-case-table-row-status">
                            <img
                              className="cargo-case-table-row-status__icon-prepared"
                              src={findStatusDocument(el?.status)}
                              alt={"иконка подготовлен"}
                            />
                            <img
                              onClick={(e) =>
                                onHandleShowTableMenu(
                                  el?.id,
                                  activeTableRowMenu,
                                  setActiveTableRowMenu,
                                  e
                                )
                              }
                              className="cargo-case-table-row-status__icon-more-btn"
                              src={moreBtnTableIcon}
                              alt={"иконка показать больше"}
                            />
                            <TableRowMenu
                              index={el?.id}
                              activeTableRowMenu={activeTableRowMenu}
                              handelTableMenu={onSelectedBol}
                            />
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            <CreateNewDocuments hiddenButtons={true} />
          </>
        )}
      </div>
      {activeCreateBolModal && (
        <CreateDocSetBolModal
          closeModal={closeModal}
          addBolCargoCase={addBolCargoCase}
          errorMessage={errorMessage}
          editDoc={editDoc}
          selectedCargoCaseBol={selectedCargoCaseBol}
          cargoCaseDocument={[selectedCargoCaseBol[0]?.cargoCase]}
        />
      )}
    </div>
  );
};
export default Bol;
